import { IOption } from '@r1-frontend/ui-react/components/select/creatableSelect';
import { TRouterCardProps } from '@r1-frontend/ui-react/organisms/Card/Router/Router';
import { TSpeedLineItemWithDescription } from '@r1-frontend/ui-react/organisms/SpeedLine/SpeedLineWithDescription';
import { TArrayTwoOrMore } from '@r1-frontend/shared/types/Array';

import { EEntity } from '~/src/features/tariffBuilder/types/EEntity';
import { IDecoderEntity, TToasterNotify } from '~/src/features/tariffBuilder/types/entity';
import { ESteps } from '~/src/features/tariffBuilder/types/ESteps';
import { TCurrentTariff } from '~/src/features/tariffBuilder/types/TCurrentTariff';
import { TLimitations } from '~/src/features/tariffBuilder/types/TLimitations';

export type TBaseSubscription = {
    id: number,
    imagePath: { desktop: string, mobile: string },
    title: string,
    cost: {
        previous: number, // oldCost - old cost
        fact: number, // delta - plus for tariff
        final: number, // cost - inside summary
    },
    benefits?: string[],
    description: string,
    descriptionFull: string,
    quantity: number,
    selectedCost?: number, // not used...
}

export type TTvSubscriptionItem = Omit<TBaseSubscription, 'imagePath'> &
    {
        contentId: number, // this parameter is using only for getting list of channels
    };

export type TTvSubscription = {
    alias: string,
    title: string,
    imagePath: string,
    items: Record<number, TTvSubscriptionItem>,
}

type TCost = {
    cost: number,
    period: number,
}

type TClient = {
    name: string,
    phone: string,
    contactPhone?: IOption,
}

export type TTimeSlot = {
    date: string,
    hour: string,
    comment?: string,
}

export type TRouter = Pick<
    TRouterCardProps,
    'images' | 'title' | 'description' | 'labels' | 'characteristics'
> & {
    id: number,
    globalId: number,
    costs: Record<number, TCost>,

    quantity: number,
    selectedCost: number,
}

export type TEntityDescription = {
    header?: string,
    description?: string,
}

export interface IChangePlanWebcabData {
    data?: string,
    hasError?: boolean,
    errorCode?: string | number,
    errorMessage?: string,
}

export type TInitialState = {
    initialized: boolean,
    loading: boolean,
    currentStep: ESteps,

    discount: {
        percent: number,
        value: number,
    },

    [EEntity.speed]: TArrayTwoOrMore<TSpeedLineItemWithDescription>,
    selectedSpeed: number,
    speedRestrictions?: { min?: number, max?: number },

    [EEntity.onlineCinemas]: Record<number, TBaseSubscription>,
    [EEntity.tv]: Record<string, TTvSubscription>,
    [EEntity.additional]: Record<number, TBaseSubscription>,
    [EEntity.antivirus]: Record<number, TBaseSubscription>,
    [EEntity.security]: Record<number, TBaseSubscription>,

    [EEntity.routers]: Record<number, TRouter>,
    [EEntity.decoders]: Record<number, IDecoderEntity>,

    entityDescription: Record<string, TEntityDescription>,

    selectedEntityIds: {
        [EEntity.services]: number[],
        [EEntity.decoders]: number[],
        [EEntity.routers]: number[],
    },

    hasSmartTv: boolean,

    limitations: {
        [EEntity.routers]: TLimitations,
        [EEntity.decoders]: TLimitations,
    },
    toaster: TToasterNotify,

    client: TClient,

    selectedTimeSlot: TTimeSlot | null,

    agreement: {
        agreementId: number | null,
        agreementNumber: string | null,
        isDouble: boolean,
        hasError: boolean,
        errorMessage: string,
    },

    salePackageId: string | null,

    planId?: number,

    maximumTakenStep: ESteps,

    currentTariff?: TCurrentTariff,
    changePlanWebcabData?: IChangePlanWebcabData,
    requestId?: string,
    replanIsError?: boolean,
}

const toaster: TToasterNotify = {
    type: 'info',
    message: '',
};

const initialState: TInitialState = {
    initialized: false,
    loading: false,

    currentStep: ESteps.SpeedAndTv,
    maximumTakenStep: ESteps.SpeedAndTv,

    discount: {
        percent: 0,
        value: 0,
    },

    // @todo remove
    // @ts-ignore
    speed: {},
    selectedSpeed: 0,
    speedRestrictions: undefined,

    onlineCinemas: {},
    tv: {},
    additional: {},
    antivirus: {},
    security: {},
    routers: {},
    decoders: {},

    entityDescription: {},

    hasSmartTv: false,

    limitations: {
        routers: { total: 0, installment: 0 },
        decoders: { total: 0, installment: 0 },
    },
    toaster: toaster,

    selectedEntityIds: {
        [EEntity.services]: [],
        [EEntity.decoders]: [],
        [EEntity.routers]: [],
    },

    client: { name: '', phone: '' },

    selectedTimeSlot: null,

    salePackageId: null,

    agreement: {
        agreementId: null,
        agreementNumber: null,
        isDouble: false,
        hasError: false,
        errorMessage: '',
    },
};

export default initialState;
